import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';
import AIAssistant from '../common/AIAssistant';

const MainLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        overflow: 'hidden',
        background: theme => theme.palette.mode === 'dark'
          ? 'linear-gradient(180deg, #081525 0%, #07111f 100%)'
          : 'linear-gradient(180deg, #FFFFFF 0%, #EAF5F7 100%)',
      }}
    >
      <Sidebar collapsed={sidebarCollapsed} />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0, minHeight: 0 }}>
        <Header
          onToggleSidebar={() => setSidebarCollapsed(prev => !prev)}
          sidebarCollapsed={sidebarCollapsed}
          aiOpen={aiOpen}
          onToggleAI={() => setAiOpen(prev => !prev)}
        />
        <Box
          component="main"
          sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', p: 2 }}
        >
          <Outlet />
        </Box>
      </Box>
      <AIAssistant open={aiOpen} onClose={() => setAiOpen(false)} />
    </Box>
  );
};

export default MainLayout;
